/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DivideCircleIcon16Light } from './DivideCircleIcon16Light';
import { DivideCircleIcon16Regular } from './DivideCircleIcon16Regular';
import { DivideCircleIcon16Solid } from './DivideCircleIcon16Solid';
import { DivideCircleIcon20Light } from './DivideCircleIcon20Light';
import { DivideCircleIcon20Regular } from './DivideCircleIcon20Regular';
import { DivideCircleIcon20Solid } from './DivideCircleIcon20Solid';
import { DivideCircleIcon24Regular } from './DivideCircleIcon24Regular';
import { DivideCircleIcon24Solid } from './DivideCircleIcon24Solid';
import { DivideCircleIcon32Regular } from './DivideCircleIcon32Regular';
import { DivideCircleIcon64Regular } from './DivideCircleIcon64Regular';
var sizes = {
    16: {
        light: DivideCircleIcon16Light,
        regular: DivideCircleIcon16Regular,
        solid: DivideCircleIcon16Solid,
    },
    20: {
        light: DivideCircleIcon20Light,
        regular: DivideCircleIcon20Regular,
        solid: DivideCircleIcon20Solid,
    },
    24: {
        regular: DivideCircleIcon24Regular,
        solid: DivideCircleIcon24Solid,
    },
    32: {
        regular: DivideCircleIcon32Regular,
    },
    64: {
        regular: DivideCircleIcon64Regular,
    },
};
export var DivideCircleIcon = forwardRef('DivideCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
